import { useEffect } from 'react';
import { useAPIContext, useStoreContext } from '../../../../components/Context';
import { getDraftPayment } from '../../draft/payment/selectors';
import { getDraftRequirements } from '../../draft/requirements/selectors';
import { getDraftRoute } from '../../draft/route/selectors';
import { memoPoints, set as setIn } from '../../utils';
import { getZoneName } from '../../zone/selectors';
import { createAsyncState } from '../hooks';
import { toEstimateRequest } from './selectors';
import { getDraftCoupon } from '../../draft/coupon/selectors';
var useEstimateAsync = createAsyncState('estimate');
export var useEstimateQuery = function () {
    var state = useStoreContext()[0];
    var estimate = useAPIContext().estimate;
    var _a = useEstimateAsync(), asyncState = _a[0], actions = _a[1];
    var points = memoPoints(getDraftRoute(state));
    var payment = getDraftPayment(state);
    var zoneName = getZoneName(state);
    var coupon = getDraftCoupon(state);
    var requirements = getDraftRequirements(state);
    useEffect(function () {
        if (!estimate) {
            return;
        }
        var body = toEstimateRequest({
            zoneName: zoneName,
            points: points,
            payment: payment,
            requirements: coupon ? setIn(requirements, ['coupon'], coupon) : requirements,
        });
        if (body) {
            actions.start();
            return estimate({
                body: body,
                onError: actions.error,
                onSuccess: actions.success,
            });
        }
        // при обновлении запроса эстимейт всегда нужно сбрасывать
        // иначе можно получить не консистентное состояние
        actions.reset();
    }, [actions, estimate, payment, points, requirements, coupon, zoneName]);
    return asyncState;
};
export var useEstimateState = function () { return useEstimateAsync()[0]; };
